export type TimelineEventType =
  | 'icp_analysis'
  | 'measurement'
  | 'journal_entry'
  | 'image'
  | 'task'
  | 'dosing'
  | 'livestock'
  | 'ai_insight';

export interface TimelineEvent {
  id: string;
  type: TimelineEventType;
  occurredAt: string;
  title: string;
  summary: string | null;
  thumbnailUrl: string | null;
  /** Variant within the type (livestock: 'added' | 'deceased'); null/absent otherwise. */
  subtype?: string | null;
  /** Link suggested by the API; the UI uses timelineEventHref() (routes defined in App.tsx). */
  deepLinkPath: string;
  sourceId: string;
  hasAiInsight: boolean;
}

export interface TimelineResult {
  events: TimelineEvent[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface TimelineResponse {
  data: TimelineResult;
}

export type TimelineFilterType = 'all' | 'water_tests' | 'photos' | 'journal' | 'tasks' | 'livestock' | 'ai_insights';

export const FILTER_TO_API_TYPES: Record<TimelineFilterType, TimelineEventType[] | undefined> = {
  all: undefined,
  water_tests: ['icp_analysis', 'measurement'],
  photos: ['image'],
  journal: ['journal_entry'],
  tasks: ['task'],
  livestock: ['livestock'],
  ai_insights: ['ai_insight'],
};

/**
 * Discrete zoom granularities for the dashboard timeline (epic #1442).
 * Optional and additive — omitting it from a request preserves the
 * existing unbounded query behaviour.
 */
export type TimelineRange = 'month' | 'year' | 'all';

/**
 * Query params accepted by timelineService.getTimeline. `range` is optional
 * and additive (epic #1442, sub-issue frontend-data) — existing call sites
 * that do not pass it see byte-identical request behaviour.
 */
export interface TimelineParams {
  limit?: number;
  /** Pagination cursor: only events strictly before this ISO timestamp. */
  before?: string;
  /** Comma-separated API event types, e.g. "journal_entry,image". */
  types?: string;
  range?: TimelineRange;
}
